import { connect } from 'react-redux';
import ScribeFontSizeInput from './ScribeFontSizeInput';
import { scribeSetFontSizeAndSave } from '../../actions';
const mapStateToProps = (state) => {
    const { scribeTranscriptUI: { fontSize }, } = state;
    return {
        fontSize,
    };
};
export default connect(mapStateToProps, {
    scribeSetFontSizeAndSave,
})(ScribeFontSizeInput);
